import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { startCase, toLower } from 'lodash';
import { Box, Flex, Text } from 'atoms';
import { Rupee } from 'components';
import { GetFullName } from 'utils';
import { DateSelection } from 'components/pages/collection';

const Container = styled(Box)`
	padding: 10px 30px 25px 30px;
	color: white;
	background-color: ${(props) => props.theme.colors.primary};
	font-size: 10px;
	position: relative;
`;

const DashboardLabel = ({ dashboard }) => [
	{ label: 'Cash', hasCash: true, value: dashboard?.cash || 0 },
	{ label: 'UPI', hasCash: true, value: dashboard?.upi || 0 },
	{ label: 'Cheque', hasCash: true, value: dashboard?.cheque || 0 },
	{ label: 'NEFT', hasCash: true, value: dashboard?.neft || 0 },
	{ label: 'IR', hasCash: false, value: dashboard?.bill_back || 0 },
	{ label: 'IS', hasCash: false, value: dashboard?.no_bill_back || 0 },
];

export default function DashInfo() {
	const { dashboard } = useSelector((state) => state.salesman);
	const { me = {}, selectedSalesMan = {} } = useSelector((state) => state.user);

	return (
		<Container>
			<Flex justifyContent="space-between" mb="1rem">
				<Box>
					<Text id="salesman-name" fontWeight="600">
						{me.type === 'Additional Resource'
							? startCase(toLower(GetFullName.userFullName(selectedSalesMan)))
							: startCase(toLower(GetFullName.userFullName(me)))}
					</Text>
				</Box>
				<DateSelection />
				<Flex alignItems="center">
					<Text fontWeight="300">Total:&nbsp;</Text>
					<Text fontWeight="600">
						<Rupee>{dashboard?.total}</Rupee>
					</Text>
				</Flex>
			</Flex>
			<Flex justifyContent="space-between">
				{DashboardLabel({ dashboard }).map(({ label, hasCash, value }) => (
					<Box key={label}>
						<Text fontWeight="600">{hasCash ? <Rupee>{value}</Rupee> : value}</Text>
						<Text fontWeight="300" pt="5px">
							{label}
						</Text>
					</Box>
				))}
			</Flex>
			<Flex position="absolute" bottom="5px">
				<Text>IR = Invoice Returned, IS = Invoice Settled</Text>
			</Flex>
		</Container>
	);
}
